// 折线图
export const option = {
  title: {
    text: "完成任务数"
  },
  tooltip: {
    trigger: "axis"
  },
  legend: {
    data: ["2025-03", "2025-04"],
    y: "bottom",
    itemGap: 80
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "8%",
    containLabel: true
  },
  toolbox: {
    feature: {
      saveAsImage: {}
    }
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [1,2,3,4,5,6,7,8,9,10,11,12]
  },
  yAxis: {
    type: "value"
  },
  series: [
    {
      name: "2025-03",
      type: "line",
      stack: "Total",
      data: [120, 0,132, 101, 134, 90, 230, 210]
    },
    {
      name: "2025-04",
      type: "line",
      stack: "Total",
      data: [220, 182, 191, 234, 290, 330, 310]
    }
  ]
};
